"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProgressOverlayLoaderIndicator = ProgressOverlayLoaderIndicator;
const React = __importStar(require("react"));
const Elements = __importStar(require("../elements"));
const styled_components_1 = __importDefault(require("styled-components"));
const IndicatorBox = (0, styled_components_1.default)(Elements.LoadingIndicatorBox) `
  width: 340px;

  padding: 20px 15px 15px 15px;
`;
const ProgressOuter = styled_components_1.default.div `
  border: 1px solid #657581;
  border-style: outset;
  border-radius: 3px;

  width: 95%;
  margin: 0 auto;
`;
const ProgressInner = styled_components_1.default.div `
  border: 1px solid #fff;
  border-radius: 3px;
  text-align: center;
  padding: 2px 0;

  background: linear-gradient(#e6e6e6, #f0f0f0, #e6e6e6);

  font-size: 12px;
  position: relative;
`;
const TextContainer = styled_components_1.default.div `
  position: relative;
  z-index: 5;
`;
const FillContainer = styled_components_1.default.div `
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  display: inline-block;
  background: linear-gradient(#7fbddb, #c2dfed, #7fbddb);
  width: ${props => props.percent}%;
  z-index: 0;
`;
const LoadingBarContainer = styled_components_1.default.div `
  margin-top: 20px;
`;
function ProgressOverlayLoaderIndicator({ active, message, current, max, children }) {
    return (React.createElement("div", { style: {
            position: "absolute",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            display: "flex",
            flexDirection: "column"
        } },
        children,
        active && (React.createElement(Elements.LoadingOverlay, null,
            React.createElement("div", { style: {
                    height: "100%",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                } },
                React.createElement(IndicatorBox, null,
                    React.createElement(ProgressOuter, null,
                        React.createElement(ProgressInner, null,
                            React.createElement(React.Fragment, null,
                                React.createElement(FillContainer, { percent: (current / max) * 100 }),
                                React.createElement(TextContainer, null,
                                    `${message}`,
                                    React.createElement("br", null),
                                    `Step: ${current} / ${max}`)))),
                    React.createElement(LoadingBarContainer, null,
                        React.createElement(Elements.LoadingBar, null))))))));
}
//# sourceMappingURL=progress.js.map